import { useState, useRef } from 'react'
import { useDisclosure } from '@chakra-ui/react'
import { updateDoc, doc } from 'firebase/firestore'
import { AdditionalDetails } from '../../../../../../types/FirestoreUser'
import { getEffectiveServices } from '../../../../../../utils/firebaseServiceContext'

const useDeleteTrial = (
  uid: string,
  additionalDetails: Partial<AdditionalDetails>,
  setAdditionalDetails: React.Dispatch<
    React.SetStateAction<Partial<AdditionalDetails>>
  >
) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const cancelRef = useRef<any>()
  const [trialToDelete, setTrialToDelete] = useState<string | null>(null)

  const handleDeleteTrial = (study: string) => {
    setTrialToDelete(study)
    onOpen()
  }

  const confirmDeleteTrial = async () => {
    if (trialToDelete) {
      const docRef = doc(getEffectiveServices().firestore, 'users', uid)

      try {
        const newArray = (additionalDetails.clinicalTrials || []).filter(
          (trial: any) => trial.id !== trialToDelete
        )

        await updateDoc(docRef, {
          'additionalDetails.clinicalTrials': newArray,
        })

        setAdditionalDetails((prevDetails: any) => ({
          ...prevDetails,
          clinicalTrials: newArray,
        }))

        setTrialToDelete(null)
        onClose()
      } catch (error) {
        console.error('Error deleting trial:', error)
      }
    }
  }

  return {
    isOpen,
    onOpen,
    onClose,
    cancelRef,
    handleDeleteTrial,
    confirmDeleteTrial,
  }
}

export default useDeleteTrial
